
export default {
  async getOrganisationCampaigns ({ state, commit }) {
    const data = await this.$api.getCampaigns(state.currentPage)
    commit('SET_PAGES', data.pages)
    commit('SET_ORGANISATION_CAMPAIGNS', data.campaigns)
  }
}
